export default __webpack_public_path__ + "static/media/EraseIcon.8af15b52.svg";